export function isMobile() {
  const matcher = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  return window.navigator.userAgent.match(matcher)
}

export function delimiterAmount(n) {
  if (!n || typeof n == "undefined") return;
  let str = n.split(".");
  let re = /\d{1,3}(?=(\d{3})+$)/g;
  let n1 = str[0].replace(re, "$&,");
  return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}`;
}



// WEBPACK FOOTER //
// ./src/utils/tools.js